import styles from './PieChart.module.css';

interface PieEntry {
    label: string;
    count: number;
    color?: string;
}

interface PieChartProps {
    entries: PieEntry[];
    total?: number;
}

const DEFAULT_COLORS = [
    'var(--option-color-1)',
    'var(--option-color-2)',
    'var(--option-color-3)',
    'var(--option-color-4)',
    'var(--option-color-5)',
    'var(--option-color-6)',
];

export function PieChart({ entries, total }: PieChartProps) {
    const totalCount = total ?? entries.reduce((acc, e) => acc + e.count, 0);

    if (entries.length === 0 || totalCount === 0) {
        return <p className={styles.empty}>Sin datos</p>;
    }

    // Build conic-gradient segments
    let cumulative = 0;
    const segments = entries.map((entry, i) => {
        const pct = (entry.count / totalCount) * 100;
        const start = cumulative;
        cumulative += pct;
        return {
            ...entry,
            pct,
            start,
            end: cumulative,
            color: entry.color ?? DEFAULT_COLORS[i % DEFAULT_COLORS.length],
        };
    });

    const gradient = segments
        .map((s) => `${s.color} ${s.start.toFixed(2)}% ${s.end.toFixed(2)}%`)
        .join(', ');

    return (
        <div className={styles.wrapper}>
            <div
                className={styles.pie}
                style={{ background: `conic-gradient(${gradient})` }}
                role="img"
                aria-label="Grafico de torta"
            />
            <div className={styles.legend}>
                {segments.map((s) => (
                    <div key={s.label} className={styles.legendRow}>
                        <span
                            className={styles.legendDot}
                            style={{ background: s.color }}
                        />
                        <span className={styles.legendLabel}>{s.label}</span>
                        <span className={styles.legendStats}>
                            {s.count} <span className={styles.legendPct}>({Math.round(s.pct)}%)</span>
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
